export const SHOW = 'SHOW';
export const HIDE = 'HIDE';
